/**
 * Messages dédiés aux refus 403 de l'acceptation d'une invitation (même patron que
 * `org-errors.js`) : le serveur répond en français quelle que soit la langue de l'interface,
 * et le message brut ne dit pas quoi faire. Clés écrites en littéral (le gate `keys.test.js`
 * ne voit pas une clé calculée).
 */

/**
 * @param {unknown} error
 * @param {(key: string, options?: object) => string} t
 * @param {{ email?: string }} [contexte] adresse du compte connecté (jamais l'adresse invitée)
 * @returns {string|null} `null` pour toute autre erreur : l'appelant garde son message générique
 */
export function messageInvitation(error, t, contexte = {}) {
  switch (error?.details?.code) {
    case 'INVITATION_EMAIL_MISMATCH':
      return t('invitationErrors.emailMismatch', { email: contexte.email ?? '' });
    case 'EMAIL_NOT_VERIFIED':
      return t('invitationErrors.emailNotVerified');
    default:
      return null;
  }
}
